import { Parser } from '../../object/field-formula-side-sheet/field-formula-side-sheet/formula';

export function extractJSONFromBuildJSON(jsonBuildString: string): any {
  const parsed = Parser(jsonBuildString);
  const buildArgs = parsed.args[0];

  return buildArgs;
}
